import { Component, OnInit,ElementRef, AfterViewInit, ViewChild } from '@angular/core';
import { Http, Headers, Response,RequestOptions} from '@angular/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { AlertService,UserService } from '../_services/index';
declare let $: any;
declare let Ladda:any
import { DatePipe } from '@angular/common';
import { NgForm } from '@angular/forms';
import { environment } from '../../environments/environment';
import { Router, ActivatedRoute,Params} from '@angular/router';
import { Helper } from '../_helpers/index';

@Component({
  selector: 'app-contactdetail',
  templateUrl: './contactdetail.component.html',
  styleUrls: ['./contactdetail.component.css'],
})

export class ContactdetailsComponent{
data:any;
  backendUrl:any;
  sel_id:any;
  loadingnew = false;
  loading = false;
  complexForm:FormGroup;
  model: any = {};
  id:number;
  wifiId:number;
  branchID:number;
  dataVal:any;
  contact_id:any;
  uploadFile:any;
  fileExtensionError: boolean = false;
  fileExtensionMessage: any;
  hasBaseDropZoneOver: boolean = false;
  sizeLimit = 5000000;
  time_zone:any;

constructor(fb: FormBuilder,private http: Http,private datePipe: DatePipe,private userService:UserService,private router: Router,private activatedRoute: ActivatedRoute,private helper: Helper) {
    this.complexForm = fb.group({
      // To add a validator, we must first convert the string value into an array. The first item in the array is the default value if any, then the next item in the array is the validator. Here we are adding a required validator meaning that the firstName attribute must have a value in it.

      // We can use more than one validator per field. If we want to use more than one validator we have to wrap our array of validators with a Validators.compose function. Here we are using a required, minimum length and maximum length validator.

    })

  }
  ngOnInit(){
  let url=window.location.hostname;
    // if(url=='app.foodbot.ai' || url=='dashboard.foodbot.ai'){this.backendUrl=environment.prod}
    // else if(url=='stage.foodbot.ai'){ this.backendUrl=environment.stage}
    // else if(url=='uat.foodbot.ai'){ this.backendUrl=environment.uat}
    // else{ this.backendUrl=environment.local}
    if (url == 'app.foodbot.ai' || url == 'dashboard.foodbot.ai') { this.backendUrl = environment.prod } else if (url == 'stage.foodbot.ai') { this.backendUrl = environment.stage } 
    else if (url == 'uat.foodbot.ai') { this.backendUrl = environment.uat } 
    else if (url == '127.0.0.1') { this.backendUrl = environment.local } 
    else { 
      this.backendUrl=window.location.origin
      this.backendUrl+="/apis"
    }

    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
     let restaurant_id=currentUser.restaurant_id;
     this.time_zone = currentUser.time_zone ? currentUser.time_zone : 'America/Mexico_City';
     var sql1="SELECT * FROM fb_branches  where restaurant_id="+restaurant_id;
        this.userService.getdata(this.backendUrl,JSON.stringify({'query': sql1}))
          .subscribe(data => {
            if(data.length > 0) {
              this.dataVal = data;
              this.contact_id = data[0].branch_id;
              this.model.phone_number = data[0].phone_number;
            }else {
              this.dataVal = '';
            }            
        });
  var self=this;
$(document).ready(function(){
$.validator.addMethod("clsRequired", function(value, element) { 
  return value == '' || value.trim().length != 0; 
}, "This Field is required");

  $("input").on("keypress", function(e) {
    if (e.which === 32 && !this.value.length)
        e.preventDefault();
});
  if(!self.contact_id) {

  $('#network_detail').validate({
        rules:{
          phone_number:{required:true,maxlength:10,number:true,minlength:8},
        },
        messages:{
          phone_number:{required:"This Field is required",number:"Please enter a valid phone number.",minlength:"Please enter a valid phone number."},

        },
        errorPlacement: function(error, element) {
          if (element.type == 'checkbox') {
            error.appendTo(element.parent());
          }
          else {
            error.insertAfter(element);
          }
        }

      })

  }else {
    $('#network_detail').validate({
        rules:{
          phone_number:{required:true,maxlength:10,number:true,minlength:8},

        },
        messages:{
          phone_number:{required:"This Field is required",number:"Please enter a valid phone number.",minlength:"Please enter a valid phone number."},

        },
        errorPlacement: function(error, element) {
          if (element.type == 'checkbox') {
            error.appendTo(element.parent());
          }
          else {
            error.insertAfter(element);
          }
        }

      })
  }
            })
  }

fileChange(event) {
    let fileList: FileList = event.target.files;
    console.log(fileList);
     let file = event.target.files[0];
     let photoName = file.name;
     let fileExtension = photoName.split('.').pop();
     if(file.size > 2000000) {
      $('#inputImage').val('');
      alert('Max. allowed filesize is 2MB');
      return false;
    }
    let obj = this;
    iEdit.open(file,true,function(res) {
    $('.img-thumbnail').hide();
    $('#ier').attr('src',res);
    $('#ier').show();
    $('.pull-right').prop('disabled',true);
    obj.completeProcess(res,photoName,fileExtension);
    });
  }

  completeProcess(data,name,fileExtension) {
        var arr = data.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        var fileData = new File([u8arr], name, {type:fileExtension}); 
        let formData:FormData = new FormData();
        formData.append('fpostfix','branch');
        formData.append('des_path', 'branch');
        formData.append('file', fileData ,fileData.name);
        console.log(fileData);
        this.userService.upload_sep_promotion(this.backendUrl,formData)
            .subscribe(
                data => {
                this.loading = false;
                $('.pull-right').prop('disabled',false);                  
                  this.handleUpload(data)                  
                },
                error => console.log(error)
            )
  }

handleUpload(data): void {
   console.log("all data is=",data.url)
    if (data) {
      this.uploadFile = data.url;
    }
  }
  save_network()
  {
    let dayData = '';
    let date=new Date();
    let date_time=moment(date).format("YYYY-MM-DD HH:mm:ss");
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let restaurant_id=currentUser.restaurant_id;
    if($('#network_detail').valid())
    {
      var l = Ladda.create( document.querySelector( '#save_network') );
      l.start();
      if(this.contact_id){
        let userdata = {
         phone_number : this.model.phone_number,
         image : this.uploadFile,
         restaurant_id : restaurant_id,
         updated_at : this.helper.getDateTimeInClientTz(date_time,this.time_zone),
        };
        let sql="update fb_branches set ? where branch_id="+this.contact_id;
        this.userService.insert(this.backendUrl,JSON.stringify({'query': sql,'data':userdata}))
          .subscribe(data => {
            l.stop();
            this.ngOnInit();
            $('#success').html('contact details updated successfully');
                   $('#success').show();
                   setTimeout(function(){
                           $('#success').hide();
                    },3000);
          });
      }
      else{
        let userdata = {
          phone_number : this.model.phone_number,
          image : this.uploadFile,
          restaurant_id : restaurant_id,
          created_at : this.helper.getDateTimeInClientTz(date_time,this.time_zone),
          updated_at : this.helper.getDateTimeInClientTz(date_time,this.time_zone),
          status : 1
        };
        let sql="insert into fb_branches SET ?"
        this.userService.insert(this.backendUrl,({'query': sql,'data':userdata}))
          .subscribe(data => {
            this.contact_id = data.id;
            l.stop();
            this.ngOnInit();
            $('#success').html('contact details saved successfully');
                   $('#success').show();
                   setTimeout(function(){
                           $('#success').hide();
                    },3000);
          });
      }

    }
  }
}



// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/contactdetail/contactdetail.component.ts